export type JwtPayload = {
  exp?: number;
  iat?: number;
  iss?: string;
  sub?: string;
  displayName?: string;
  roles?: string[];
};

export function jwtRefreshMarginMs(expMs: number | null, iatMs: number | null): number {
  if (expMs == null) return 100;
  if (iatMs == null) return 60000;
  const span = expMs - iatMs;
  return Math.min(120000, Math.max(5000, span * 0.15));
}

export function safeDecodeJwtPayload(token: string | null): JwtPayload | null {
  try {
    if (!token) return null;
    const parts = token.split(".");
    if (parts.length < 2) return null;
    const json = atob(parts[1].replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(json) as JwtPayload;
  } catch {
    return null;
  }
}

export function parseJwtTimes(token: string) {
  const payload = safeDecodeJwtPayload(token);
  if (!payload) return null;
  return {
    expMs: payload.exp != null ? payload.exp * 1000 : null,
    iatMs: payload.iat != null ? payload.iat * 1000 : null,
  };
}
